import { getApiUrl } from '@/js/utils/getApiUrl';

export function getManagerReportArchiveUrl(reportId: number): string {
  const url = new URL(
    getApiUrl(`/api/personal/report/${reportId}/archive/`),
    window.location.origin,
  );
  url.searchParams.set('allFile', '1');
  return url.toString();
}

export function getManagerReportSignUrl(reportId: number): string {
  return getApiUrl(`/api/personal/report/${reportId}/get-sign/`);
}
